/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace variable-name align max-line-length */

import * as $                           from 'jquery';

import {ProjectElement}                 from './project.element';
import {ProjectElementType}             from './project.element.type';
import {Project}                        from '../project';

import {
  SimulationJob,
  SimulationStatusType
}                                       from '@/models/sim/simulation.job';
import {BatchSimJob}                    from "@/models/sim/batch.sim.job";

import {BlobType}                       from '../blob';

import {Logger}                         from '@/util/logger';

import {empty}                          from '@/util/util';

import {TextEditorMetadata}             from '@/screens/ide/text.editor.metadata';
import {ProjectElementFactoryDecorator} from "@/models/project/project.element.factory.decorator";
import {PropertiesHolder}               from "@/models/properties.holder";
import {TaskUpdate}                     from "@/models/task.update";
import {TaskBatchSim}                   from "@/models/task.batch.sim";
import {TaskBatchSimFailed}             from "@/models/task.batch.sim.failed";
import {TaskBatchSimComplete}           from "@/models/task.batch.sim.complete";
import {first} from "rxjs/operators";
import {BatchViewerMetadata} from "@/screens/ide/batch.viewer.metadata";
import {BatchView} from "@/screens/ide/batchviewer/batch.view";
import {JSONBrowserMetadata} from "@/screens/ide/json.browser.metadata";
import {FileBrowserMetadata} from "@/screens/ide/file.browser.metadata";


/**
 *
 * @class BatchSimJobElement
 *
 * @brief node to maps directly to a batch result in the SWE
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
@ProjectElementFactoryDecorator('BatchSimJobElement')
export class BatchSimJobElement extends ProjectElement {

  /**
   * updates normally happen about every 1 second, so if just modulo divide by 5
   * we know to save the project every 5 updates...so we can keep the project
   * reasonably up to date when things are changing a lot...but still not be
   * constantly saving the project.
   *
   */
  private updateCount = 0;

  /** don't allow double updating */
  private downloading: boolean = false;

  /** the unique progress task we're showing in the long-running tasks popup */
  private taskId: string = '';

  protected actionKeys: string[] = [
    'viewcrash',
    'monitor',
    'renameresult',
    'deleteresult',
    'downloadkpi',
    'viewkpi',
    'viewinbrowser'
  ];

  /* all the details to track/manage the remote line simulator job */
  public _job: BatchSimJob = null;


  /** standard constructor */
  constructor(
     project: Project,
          id: string,
         job: BatchSimJob,
      parent: ProjectElement,
     taskId?: string,
    publish?: boolean,
     peType?: ProjectElementType
  ) {

    super(project, id, peType ? peType : ProjectElementType.BatchSimResult);

    this.taskId       = taskId ? taskId : TaskUpdate.generateId();
    this._job         = job;
    this._enabled     = true;
    this._label       = `[0%] #- : `;
    this._icon        = '';
    this._elementKind = 'BatchSimResult';

    if (this._job) {

      this._label     = '[' + job.progress.toFixed(0) + `%] #${job.id()} ${SimulationJob.statusString(this._job.status)}: ` + job.updated.toISOString();

      this.updateIcon();

      if (this._job.active()) {

        this._project.registerJob(this._job, this);
      }

      if (this._job.crashed()) {

        this._label = `#${this._job.id()} ${this._job.totals.completed} of ${this._job.totals.total} complete: ` + this._job.updated.toISOString();
      }
    }

    if (parent) {

      this._project.addElement(this, parent, publish);
    }

  }

  /** helper to use to for static global constructors (and factory registration) */
  static requireType() {
    console.log("requiring BatchSimJobElement");
  }

  /** drop data on this element */
  public acceptDrop(data): boolean {

    return false;
  }

  /** is this element deletable? */
  public isDeletable() : boolean {

    return true;
  }

  /** test if any blob of this type can be a child of this element */
  public acceptsBlobType(type: BlobType): boolean {

    return false;
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({job: this._job.toJSON()});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    /* recover the basics */

    super.fromNode(node);

    /* recover the job details */

    this._job  = new BatchSimJob();
    this._job.fromJSON(node.job);

    this._project.registerJob(this._job, this);

    /* if the job is running when we saved last, try to recover the status as it is now */

    if (this._job.active()) {

      this._label = '[' + this._job.progress.toFixed(0) + `%] #${this._job.id()}  ${SimulationJob.statusString(this._job.status)}:` + this._job.updated.toISOString();

      if (this._job.crashed()) {

        this._label = `#${this._job.id()} ${this._job.totals.completed} of ${this._job.totals.total} complete: ` + this._job.updated.toISOString();
      }
    }

    /* icon is set per the job's known status */

    this.updateIcon();
  }

  /* show proportional progress right in the node */
  updateProgressBar() {

    /* try to find the title <span> It's where the label is shown */

    const        id: string = this._id;
    const titleSpan: JQuery = $(`li#${id} span.fancytree-title`);

    if ( !$(titleSpan).is('span')) {

      /* can't find this node */

      return ;
    }

    /*
     * try to find the progress <div> that we insert inside the title to show as progress,
     * behind the label text.
     *
     */

    let progressBar: JQuery = $(`li#${id} span.fancytree-title div`);

    if ( !this._job.active()) {

      /* not tracking anymore */

      if ( $(progressBar).is('div')) {

        /* clear out the progress bar */

        $(progressBar).remove();
      }

      return ;
    }

    if ( !$(progressBar).is('div')) {

      /* first add of the progress */

      $(titleSpan).append('<div></div>');

      progressBar = $(`li#${id} span.fancytree-title div`);
    }

    /*
     * fetch the width of the title span, so that we know what width to use for
     * the progress bar.
     */

    const width:   number = $(titleSpan).width();
    const percent: number = this._job.progress;
    const w:       number = Math.floor(width * percent);

    $(progressBar).height(20);
    $(progressBar).width(w);

    $(progressBar).css('position',         'absolute');
    $(progressBar).css('top',              0);
    $(progressBar).css('z-index',          -1);
    $(progressBar).css('background-color', '#2a8c2e');

  }

  /** helper to update the long-running tasks panel */
  taskUpdate(message: string) {

    if (empty(this.taskId)) {

      /*
       * we're updating, so clearly in the middle of the job, could be either because we just
       * started the job, or the page was reloaded, and we are re-establishing. Either way,
       * allocate a long-running task id, so we can track progress more visibly in the long
       * running tasks pop up panel.
       *
       */

      this.taskId =  TaskUpdate.generateId();
    }

    let progress: number  = 0.0;
    let subStatus: string = '';

    if (this._job) {


      progress      = this._job.progress;
      let jobStatus = SimulationJob.statusString(this._job.status);

      if (this._job.status == SimulationStatusType.NONE) {

        jobStatus   = 'pending';
      }

      subStatus = `#${this._job.id()} ${progress.toFixed(2)}% ${jobStatus} `;

      if (this._job.crashed()) {

        subStatus = `#${this._job.id()} crashed - `;
      }
    }

    let update = new TaskBatchSim(this.taskId, `${subStatus} ${message}`, progress, this._job);

    Logger.debug(`[BatchSimJobElement] progress: ${this._id} `, update);

    this._project.services.taskMonitor.progress(update);
  }

  /* general refreshing when the job progress has changed */
  update() {

    this.updateCount++;

    /* don't redraw while we are downloading...just redraw once we have the artifacts in hand */

    if (this.downloading) {

      return ;
    }

    const flags = ['-', '\\', '|', '/'];
    let prefix  = this._job.summary;

    /* update long running task progress... */

    if ((this._job.isFailStatus())||(this._job.isCompleteStatus())) {

      if (!this._job.resolved) {

        /* its already completed or failed, but we're waiting for artifact download from Google to cloud sim */

        prefix = '(remote) post processing';

      } else {

        prefix = 'post processing';
      }
    }

    this.taskUpdate(`${flags[this.updateCount % 4]} ${prefix}`);

    const oldLabel = this._label;

    this._label     = '[' + this._job.progress.toFixed(0) + `%] #${this._job.id()} ${SimulationJob.statusString(this._job.status)}: ` + this._job.updated.toISOString();

    /*
     * during the job's normal work phase, don't do any extra updates (kills performance).  Once we are
     * resolved though, we do all updates to ensure we catch the downloads.
     *
     */

    if (!this._job.resolved) {

      if (oldLabel === this._label) {

        /*
         * if the update didn't actually change anything, then we don't do the rest of the update, because it
         * will trigger saving of the project...which will spam the serve with project save requests unnecessarily.
         *
         */

        return;
      }

    }

    this.updateIcon();

    this.redraw();

    /* try to show progress bar as background color on the node ... */

    setTimeout( () => {

      this.updateProgressBar();

    }, 0);

    if ( !this._job.active()) {

      /* time to stop watching */

      this._project.unregisterJob(this._job, this);

      /* at the end we can do any post-processing... */

      this.postProcess();

    } else {

      /* trigger a project save roughly every 5 seconds */

      /*
       * if we're only saving for the sake of saving the intermediate progress while
       * the sim is running...we don't really have to...if the page is reloaded, the status
       * will be checked and updated anyway, and when we checkpoint the project when
       * the simulation(s) complete and do their results download etc...that will be a
       * better save point anyway.
       *
       * the issue is that if you launched 30 simulations, you'll be doing project
       * saves every 5 updates for all 30 jobs, so every couple of seconds its trying to
       * do 150 project saves!  That creates a lot of stress on the system, and more chances
       * for things to go wrong.
       *
      if ((LineSimJobElement.updateCount % 5) === 0) {

        this._project.save();
      }
      *
      *
      */
    }
  }

  /** do the KPI roll up at the end (any post-processing) */
  public postProcess() {

    const bsje: BatchSimJobElement = this;

    bsje.updateProgressBar();

    bsje.downloading = true;

    Logger.debug('[BatchSimJobElement] post processing...');

    this.taskUpdate(`${bsje._parent._label} post processing ...`);

    /* do post-processing like KPI roll up ... */

    /* figure out where we are storing the rollup ... */

    const key = this._job.meta.blob_root + `/kpi-rollup.json`;

    /* aggregate... */

    Logger.debug(`[BatchSimJobElement] generate KPI rollup: ${key}`);

    bsje._project.services.swe.allKPI(this._job.resultId.toString(), key, bsje._parent._label).pipe(first())
      .subscribe(
        (kpiBlobKey: any) => {

          Logger.debug(`[BatchSimJobElement] assigning KPI rollup: `, kpiBlobKey);

          bsje._job.kpi = kpiBlobKey;

          /* post-processing is complete. */

          this.taskUpdate(`${this._parent._label} Complete.`);

          this.finalize();

        },
        (error) => {

          Logger.error(`[BatchSimJobElement] could not fetch KPI rollup: (${this._job.resultId}): `, error);

        });

  }

  public finalize() {

    Logger.debug(`[BatchSimJobElement] finalizing ...`);

    this.downloading = false;

    this._parent.unBusy();

    /* how did the cookie crumble? */

    if (this._job.crashed()||this._job.failed()) {

      /* on failure show the long-running task as failed. */

      let err = this._job.lastError;

      if (this._job.crash.length > 0) {

        err = this._job.crash[0];
      }

      const update = new TaskBatchSimFailed(this.taskId, `${this._parent._label} ${this._job.totals.failed} of ${this._job.totals.total} cells failed, see logs for details.`);

      Logger.debug(`[BatchSimJobElement] progress: ${this._id} `, update);

      this._project.services.taskMonitor.progress(update);

    } else if (this._job.complete()) {

      /* on success show the long-running task as completed. */

      const update = new TaskBatchSimComplete(this.taskId, `${this._parent._label} Completed!`);

      Logger.debug(`[BatchSimJobElement] progress: ${this._id} `, update);

      this._project.services.taskMonitor.progress(update);

      /* check if they requested auto-view when the simulation completes... */
    }

    /* make sure the thing we just created is visible */

    this._project.expand([this]);

    /* trigger a redraw */

    this._label   = `#${this._job.id()} ${this._job.totals.completed} of ${this._job.totals.total} complete: ` + this._job.updated.toISOString();

    if (this._job.crashed()) {

      this._label = `#${this._job.id()}  ${this._job.totals.completed} of ${this._job.totals.total} complete: ` + this._job.updated.toISOString();
    }

    this.redraw();

    /* trigger a save */

    Logger.debug(`[BatchSimJobElement] saving project...`);

    this.save();
  }

  /*
   * when blobs get moved/copied in bulk, project elements have to allow being told where
   * their blobs have been moved to.
   *
   */
  public adjusted(searchKey: string, replaceKey: string) {

    if (this._job !== null) {

      if (this._job.kpi === searchKey) {

        this._job.kpi = replaceKey;
      }

    }

    super.adjusted(searchKey, replaceKey);
  }

  /** fetch any secondary blobs for this element */
  public secondaryBlobs(): string[] {

    if (this._job === null) {

      return [];
    }

    if (this._job.kpi == '') {

      return [];
    }

    /* sim results have a local copy of the simulation job's log file and the output */

    return [
      this._job.kpi
    ];
  }

  public hasUserLog(): boolean {

    return false;
  }

  public hasKPI(): boolean {

    if (!this._job) {

      return false;
    }

    if (empty(this._job.kpi)) {

      return false;
    }

    return true;
  }

  /**
   * subclasses must add their menu item definition(s) to the given action set,
   * in jquery-contextmenu fashion.
   *
   * @param actionSet any
   *
   */
  public actions(actionSet: any): any {

    let crashed: boolean = false;

    if (this._job) {

      crashed = this._job.crashed();
    }

    if (crashed) {

      actionSet.viewcrash = {
        name: 'View Crash',
        icon: 'fas fa-bomb',
        disabled: false
      };
    }

    actionSet.monitor = {
      name: 'Monitor',
      icon: 'fas fa-info',
      disabled: (this._job === null)
    };

    actionSet.viewkpi = {
      name: 'KPI View',
      icon: 'fas fa-keyboard',
      disabled: !this.hasKPI()
    };

    actionSet.downloadkpi = {
      name: 'KPI (Download)',
      icon: 'fas fa-file-download',
      disabled: !this.hasKPI()
    };

    actionSet.viewinbrowser = {
      name: 'Folder Of',
      icon: 'fas fa-list',
      disabled: false
    };

    actionSet.renameresult = {
      name: 'Rename Result',
      icon: 'fas fa-tag',
      disabled: (this._job === null) || this._job.active() ||  this.isBusy()
    };

    actionSet.deleteresult = {
      name: 'Delete Result',
      icon: 'fas fa-trash',
      disabled:  this.isBusy()
    };

    return actionSet;
  }

  public updateIcon() {

    this._icon      = '';

    if (!this._job) {

      return ;
    }

    /* by default, we want to use whatever icon the job model is recommending */

    this._icon      = this._job.icon();

    /*
     * but...if the job is no longer active (failed but not completed or crashed), and
     * we have partial results, like maybe 1 of 3 cells worked, then instead of showing
     * the usual failed icon...show an in-between icon of "some are ready, some are not".
     *
     */

    if (!this._job.active() && !this._job.complete() && !this._job.crashed()) {

      /* do we have partial success? */

      if (this._job.totals.completed > 0) {

        /* yes, we have a partial result.  Show the partial result icon */

        this._icon = 'sim-result-none-32.png';
      }
    }
  }

  /** test if this element accepts the given action */
  public acceptsAction(key: string): boolean {

    return !!this.actionKeys.find(x => x === key);
  }

  /** append these elements properties to the holder */
  public properties(properties?: PropertiesHolder): PropertiesHolder {

    if (!properties) {

      properties = new PropertiesHolder();

    }

    /* show as much detail as we have */

    if (this._job) {

      /* basics */

      properties.set('Result ID', this._job.resultId);
      properties.set('Batch ID',  this._job.batchId);
      properties.set('Job ID',    this._job.jobId.toString());
      properties.set('Google ID', this._job.googleId);
      properties.set('Created',   this._job.details.created_at.toString());
      properties.set('Updated',   this._job.updated.toString());
      properties.set('Status',    SimulationJob.statusString(this._job.status));
      properties.set('KPI',       this._job.kpi);

    }

    /* add in the usual properties */

    return super.properties(properties);
  }

  /** subclasses must implement their own actions */
  public action(key: string, selection: ProjectElement[]) {

    if ( !this.actionKeys.find(x => x === key) ) {

      /* let ProjectElement handle it */

      this._parent.action(key, selection);

      return ;
    }

    switch (key) {

      case 'monitor': {
        this.monitor();
      }
      break;

      case 'viewcrash': {

        this._project.services.ide.launchWindow(
          new TextEditorMetadata(
            '',
            '',
            this._job.crash.join('\n'),
            'rawtext'
          )
        );

        break;
      }

      case 'viewkpi': {

        this._project.services.ide.launchWindow(
          new JSONBrowserMetadata(
            '',
            '',
            this._job.kpi
          )
        );

        break;
      }

      case 'downloadkpi': {

        this.dowloadBlob(BlobType.Json, this._job.kpi, 'latest', this._parent.basename() + '-kpi.json');

        break;
      }

      case 'viewinbrowser': {

        this._project.services.ide.launchWindow(FileBrowserMetadata.build(this._job.kpi, this._job.kpi));

        break;
      }

      case 'renameresult': {

        /*
         * there is nothing below a sim result hat would need path adjusting, and labeling,
         * we have to keep the job id; both in the project view and the jobs view.  So really
         * this is about having an "alternate" label after the #ID.
         *
         */

        const lsr: BatchSimJobElement = this;

        lsr._project.services.modals.open(
          'rename-element-modal',
          (name, resolve, reject) => {

            name = `#${this._job.id()} ${name.trim()}`;

            Logger.debug('[BatchSimJobElement] validating: ', name);

            /* make sure we aren't name clashing ...  */

            const peers: ProjectElement[] = lsr._parent._children;

            for (const peer of peers) {

              if (peer._label === name) {

                reject('Result of that name already exists.');

                return ;
              }

            }

            resolve(name);

          },
          (name) => {

            /* new label was accepted */

            Logger.debug('[BatchSimJobElement] renaming: ', name);

            lsr._label = `${name.trim()}`;

            lsr.redraw();

            lsr.save();
          },
          {
            title: 'Rename Result',
            placeholder: this._label
          });

        }
        break;

      case 'deleteresult': {

        if (this._job) {

          /* first delete the SWE result this node maps to... */

          // @ts-ignore
          $.LoadingOverlay('show', {

            text: 'Cleaning Result...',
            progress: 0,
            background: 'rgba(255, 255, 255, 0.85)',
            textColor: 'black',
            imageColor: 'black'
          });

          Logger.debug(`[BatchSimJobElement] deleting result ${this._job.resultId}`);

          this._project.services.swe.deleteResult(this._job.resultId.toString()).pipe(first())
            .subscribe(
              (deleteResult: any) => {

                // @ts-ignore
                $.LoadingOverlay('hide');

                /* now delete this node */

                Logger.debug(`[BatchSimJobElement] deleting element...`);

                this.deleteElements(selection);
              },
              (error) => {

                Logger.error(`[BatchSimJobElement] could not delete (${this._job.resultId}): `, error);

              });

        } else {

          Logger.debug(`[BatchSimJobElement] deleting element...`);

          this.deleteElements(selection);
        }
        break;
      }

    }
  }

  public monitor() {

    if (!this._job) {

      return ;
    }


    Logger.debug(`[BatchSimJobElement] monitoring result ${this._job.resultId} of batch ${this._job.batchId}...`);

    this._project.services.ide.launchWindow(
      new BatchViewerMetadata(
        '',
        '',
        this._job.resultId,
        `#${this._job.id()} Result`,
        '',
        BatchView.MONITOR
      )
    );
  }

}
